<template>
    <div class="row deed-owner-location-content">
        <div class="col-12 col-sm-6 col-lg-5">
            <div class="form-group">
                <MaterialSelect
                    :disabled="readonlyForm"
                    class="city-form-group city-bg"
                    id="input-cemetery"
                    name="cemetery"
                    label="name"
                    v-model.trim="form.cemetery_id"
                    :options="cemeteries"
                    @selected="onSelectCemetery"
                    v-validate="rulesField('cemetery_id', { required: true })"
                    :data-vv-scope="vScope"
                    :inputClasses="[{ 'is-invalid': fnHasError('cemetery', vScope) }]"
                    :error="fnFirstError('cemetery', vScope)"
                >
                    {{ $t(`${modelTranslateID}.cemetery`) }}
                </MaterialSelect>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-5">
            <div class="form-group">
                <MaterialSelect
                    :disabled="readonlyForm"
                    class="city-form-group city-bg"
                    id="input-occupation"
                    name="occupation"
                    label="code"
                    v-model.trim="form.occupation_id"
                    :initialData="form.occupation"
                    :ajaxOptions="{
                        url: url.lookup,
                        urlParams: { model: 'occupation', id: form.id },
                        queryParams: {
                            'match[sector.cemetery.id]': cemeteryId || form.cemetery_id
                        },
                        shouldLoadDataOnce: true,
                        shouldLoadDataOnDropdownOpen: true
                    }"
                    v-validate="rulesField('occupation_id', { required: true })"
                    :data-vv-scope="vScope"
                    :inputClasses="[{ 'is-invalid': fnHasError('occupation', vScope) }]"
                    :error="fnFirstError('occupation', vScope)"
                >
                    {{ $t(`${modelTranslateID}.occupation`) }}
                </MaterialSelect>
            </div>
        </div>
    </div>
</template>

<script>
import FormElementMixin from "../mixins/FormElementMixin";

export default {
    mixins: [FormElementMixin],
    props: {
        cemeteries: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            cemeteryId: this.form?.cemetery_id
        };
    },
    computed: {},
    methods: {
        onSelectCemetery(value) {
            this.cemeteryId = value?.id;
            this.form.occupation_id = null;
        }
    }
};
</script>

<style lang="scss" scoped>
.interment-location-content {
    display: flex;
    margin-bottom: 15px;
    gap: 20px;
}
</style>